const d3 = Object.assign({},
    require('d3-transition'),
    require('d3-selection'),
    require('d3-selection-multi'),
    require('d3-array'),
    require('d3-scale'),
    require('d3-time-format'),
    require('d3-axis'),
    require('d3-shape'));

export class LinearBubbleScaler {
    constructor ({ canvas, chartDataHelper }) {
        this.chartDataHelper = chartDataHelper;
        this.canvas = canvas;
        this.context = {
            scale: [],
            axis: []
        };
    }

    buildScales (renderContext) {
        const rs = renderContext;
        this.context = {
            scale: [],
            axis: []
        };
        const yTicks = (this.chartDataHelper.settings.yAxis && this.chartDataHelper.settings.yAxis.ticks) || 5;
        const xScale = d3.scaleLinear()
            .domain([this.chartDataHelper.minMetrics[0], this.chartDataHelper.maxMetrics[0]])
            .range([rs.r.max, this.canvas.width - rs.margin.left - rs.margin.right - rs.r.max])
            .nice();
        const yScale = d3.scaleLinear()
            .domain([this.chartDataHelper.minMetrics[1], this.chartDataHelper.maxMetrics[1]])
            .range([this.canvas.height - rs.margin.bottom - rs.margin.top - rs.r.max, rs.r.max])
            .nice(yTicks);
        const zScale = d3.scaleLinear()
            .domain([this.chartDataHelper.minMetrics[2], this.chartDataHelper.maxMetrics[2]])
            .range([rs.r.min, rs.r.max]);
        this.context.scale = [xScale, yScale, zScale];
        this.context.axis.push({
            line: d3.axisBottom(xScale),
            xOffset: rs.margin.left,
            yOffset: this.canvas.height - rs.margin.bottom
        });
        this.context.axis.push({
            line: d3.axisLeft(yScale).ticks(yTicks, 's'),
            xOffset: rs.margin.left,
            yOffset: rs.margin.top
        });
    }

    get axis () {
        return this.context.axis;
    }

    get x () {
        return this.context.scale[0];
    }

    get y () {
        return this.context.scale[1];
    }

    get z () {
        return this.context.scale[2];
    }
}
